export default {
  title: 'Moedas',
  description: 'Gerencie as moedas disponíveis para configuração de cobrança.',
  labels: {
    new: 'Nova moeda',
  },
  form: {
    title: 'Cadastro de moeda',
  },
  groups: {
    data: 'Dados da moeda',
  },
  fields: {
    code: 'Código',
    name: 'Nome',
    symbol: 'Símbolo',
    active: 'Ativa',
    order: 'Ordem',
  },
};
